(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var resizeTimer;

    function setAnnouncementBarHeight() {
      var section = document.querySelector('.announcement-bar-section');
      var height = section ? section.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
    }

    function setupMarquee(marquee) {
      var track = marquee.querySelector('.announcement-marquee__track');
      var template = marquee.querySelector('.announcement-marquee__template');
      if (!track || !template) return;

      var speed = parseInt(marquee.dataset.speed, 10) || 5;
      var itemsMarkup = template.innerHTML.trim();
      if (!itemsMarkup) return;

      track.innerHTML = '';
      track.style.removeProperty('--marquee-loop-width');
      track.style.removeProperty('--marquee-duration');

      var group = document.createElement('div');
      group.className = 'announcement-marquee__group';
      group.innerHTML = itemsMarkup;
      track.appendChild(group);

      var minWidth = marquee.clientWidth || window.innerWidth;
      while (group.offsetWidth < minWidth) {
        group.insertAdjacentHTML('beforeend', itemsMarkup);
      }

      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (link) {
        link.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);

      if (reducedMotion) return;

      var loopWidth = group.offsetWidth;
      var pixelsPerSecond = 20 + speed * 18;
      track.style.setProperty('--marquee-loop-width', loopWidth + 'px');
      track.style.setProperty('--marquee-duration', loopWidth / pixelsPerSecond + 's');
    }

    function initMarquees() {
      document.querySelectorAll('.announcement-marquee').forEach(setupMarquee);
      setAnnouncementBarHeight();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMarquees);
    } else {
      initMarquees();
    }

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initMarquees, 150);
    });

    document.addEventListener('shopify:section:load', initMarquees);
    document.addEventListener('shopify:section:unload', setAnnouncementBarHeight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.onAnnouncementHeightChange = this.setHeaderHeight.bind(this);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onAnnouncementHeightChange);
      window.addEventListener('resize', this.onAnnouncementHeightChange);
      document.addEventListener('shopify:section:load', this.onAnnouncementHeightChange);
      document.addEventListener('shopify:section:unload', this.onAnnouncementHeightChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onAnnouncementHeightChange);
      document.removeEventListener('shopify:section:load', this.onAnnouncementHeightChange);
      document.removeEventListener('shopify:section:unload', this.onAnnouncementHeightChange);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
